import { render, staticRenderFns } from "./MessageBls.vue?vue&type=template&id=95a8c788&scoped=true&"
import script from "./MessageBls.vue?vue&type=script&lang=js&"
export * from "./MessageBls.vue?vue&type=script&lang=js&"
import style0 from "./MessageBls.vue?vue&type=style&index=0&id=95a8c788&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95a8c788",
  null
  
)

export default component.exports